import type { NutritionItem } from "../api/client";

export default function TransactionNutritionBadge({ items }: { items: NutritionItem[] }) {
  if (items.length === 0) return null;

  const healthyCount = items.filter((i) => i.is_healthy).length;
  const unhealthyCount = items.filter((i) => i.is_healthy === false).length;

  return (
    <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginTop: 4 }}>
      {items.map((item) => {
        const catColor: Record<string, string> = {
          protein_rich: "var(--xpn-color-success)",
          fruits_vegetables: "var(--xpn-color-success)",
          balanced: "var(--xpn-color-info)",
          carb_heavy: "var(--xpn-color-warning)",
          high_sugar: "var(--xpn-color-danger)",
          high_fat: "var(--xpn-color-danger)",
          junk_food: "var(--xpn-color-danger)",
          alcohol: "var(--xpn-color-warning)",
          tobacco: "var(--xpn-color-danger)",
        };
        const color = catColor[item.health_category] || "var(--xpn-text-muted)";

        return (
          <span
            key={item.id}
            className="xpn-badge"
            style={{
              background: `${color}18`,
              color,
              fontSize: 11,
              padding: "2px 6px",
              borderRadius: 4,
            }}
            title={`${item.item_name}: ${item.calories ? item.calories + " cal" : "?"} | P:${item.protein_g?.toFixed(1) || "?"}g C:${item.carbs_g?.toFixed(1) || "?"}g F:${item.fat_g?.toFixed(1) || "?"}g`}
          >
            {item.item_name}
          </span>
        );
      })}
      {healthyCount > 0 && unhealthyCount === 0 && (
        <span className="xpn-badge" style={{ background: "var(--xpn-color-success)18", color: "var(--xpn-color-success)", fontSize: 11, padding: "2px 6px", borderRadius: 4 }}>
          ✅ Healthy
        </span>
      )}
      {unhealthyCount > 0 && (
        <span className="xpn-badge" style={{ background: "var(--xpn-color-danger)18", color: "var(--xpn-color-danger)", fontSize: 11, padding: "2px 6px", borderRadius: 4 }}>
          ⚠️ {unhealthyCount} unhealthy
        </span>
      )}
    </div>
  );
}
